import "./ReferralNetwork.module.css";
import VaultHeader from "@/reusable_sections/Header";
import Referral from "./sections/Referral";
import Partners from "./sections/Partners";
import ReferralBenefits from "./sections/ReferralBenefits";
import VaultFooter from "@/reusable_sections/Footer";
export default function ReferralNetworkPage() {
  return <div>
      <VaultHeader />
      <Referral />
      <Partners />
      <ReferralBenefits />
      <VaultFooter />
    </div>;
}